"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScreenInput = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var lodash_1 = tslib_1.__importDefault(require("lodash"));
var react_1 = tslib_1.__importStar(require("react"));
var react_dropdown_1 = tslib_1.__importDefault(require("react-dropdown"));
require("react-dropdown/style.css");
var ChampionshipHandicapCalculator_1 = require("./ChampionshipHandicapCalculator");
require("./styles.less");
var util_1 = require("./util");
function ScreenInput(_a) {
    var eventList = _a.eventList, scoreList = _a.scoreList, gender = _a.gender, setGender = _a.setGender, score = _a.score, setScore = _a.setScore, handicapIndex = _a.handicapIndex, setHandicapIndex = _a.setHandicapIndex, setEvent = _a.setEvent, eventPreselected = _a.eventPreselected, setAverageScoreUsed = _a.setAverageScoreUsed;
    var _b = react_1.useState(util_1.DEFAULT_DROPDOWN_SCORE), handicapDropdownValue = _b[0], setHandicapDropdownValue = _b[1];
    var handleGenderChange = function (ev) {
        setGender(ev.target.value);
    };
    var handleHandicapDropdownChange = function (ev) {
        var scoreObj = JSON.parse(ev.value);
        var scoreValue = util_1.DEFAULT_SCORE;
        if (scoreObj || scoreObj.text !== util_1.DEFAULT_SCORE.text) {
            scoreValue = scoreObj;
        }
        setAverageScoreUsed(true);
        setScore(scoreValue);
        setHandicapIndex('');
        setHandicapDropdownValue(ev.value);
    };
    var handleHandicapIndexChange = function (ev) {
        var value = ev.target.value;
        setHandicapIndex(value);
        setAverageScoreUsed(false);
        setHandicapDropdownValue(util_1.DEFAULT_DROPDOWN_SCORE);
    };
    var handleCourseChange = function (ev) {
        var obj = JSON.parse(ev.value);
        setEvent(obj);
    };
    var handicapDropdown = function () {
        var scoreOptions = [];
        if (!lodash_1.default.isEmpty(scoreList)) {
            scoreList.forEach(function (option) {
                scoreOptions.push({ value: JSON.stringify(option), label: option.text });
            });
        }
        scoreOptions.unshift(util_1.DEFAULT_DROPDOWN_SCORE);
        return (react_1.default.createElement(react_dropdown_1.default, { className: 's-dropdown', placeholder: util_1.DEFAULT_DROPDOWN_SCORE.label, options: scoreOptions, value: handicapDropdownValue, onChange: handleHandicapDropdownChange }));
    };
    var courseDropdown = function () {
        var eventOptions = [];
        if (!lodash_1.default.isEmpty(eventList)) {
            eventList.forEach(function (option) {
                eventOptions.push({ value: JSON.stringify(option), label: option.event });
            });
        }
        eventOptions.unshift({ value: JSON.stringify(util_1.DEFAULT_EVENT), label: util_1.DEFAULT_EVENT.event });
        return (react_1.default.createElement(react_dropdown_1.default, { placeholder: util_1.DEFAULT_EVENT.event, className: 's-dropdown', options: eventOptions, onChange: handleCourseChange }));
    };
    return (react_1.default.createElement("div", { className: 's-form' },
        react_1.default.createElement("div", { className: 's-flex-column' },
            react_1.default.createElement("div", { className: 's-input-section', onChange: handleGenderChange },
                react_1.default.createElement("label", { className: classnames_1.default('s-radio-label', gender === ChampionshipHandicapCalculator_1.GENDER_OPTIONS.MALE ? 'active' : ''), htmlFor: ChampionshipHandicapCalculator_1.GENDER_OPTIONS.MALE },
                    react_1.default.createElement("input", { type: 'radio', name: 'gender-select', className: 's-radio-option', id: ChampionshipHandicapCalculator_1.GENDER_OPTIONS.MALE, value: ChampionshipHandicapCalculator_1.GENDER_OPTIONS.MALE, onChange: handleGenderChange, checked: gender === ChampionshipHandicapCalculator_1.GENDER_OPTIONS.MALE }),
                    react_1.default.createElement("span", null, "Male")),
                react_1.default.createElement("label", { className: classnames_1.default('s-radio-label', gender === ChampionshipHandicapCalculator_1.GENDER_OPTIONS.FEMALE ? 'active' : ''), htmlFor: ChampionshipHandicapCalculator_1.GENDER_OPTIONS.FEMALE },
                    react_1.default.createElement("input", { type: 'radio', name: 'gender-select', className: 's-radio-option', id: ChampionshipHandicapCalculator_1.GENDER_OPTIONS.FEMALE, value: ChampionshipHandicapCalculator_1.GENDER_OPTIONS.FEMALE, onChange: handleGenderChange, checked: gender === ChampionshipHandicapCalculator_1.GENDER_OPTIONS.FEMALE }),
                    react_1.default.createElement("span", null, "Female")))),
        react_1.default.createElement("div", { className: 's-flex-column' },
            react_1.default.createElement("div", { className: 's-input-section' },
                react_1.default.createElement("label", { className: 's-input-handicap-label first' }, "Enter your Handicap Index\u00AE"),
                react_1.default.createElement("input", { type: 'text', id: 'controlled-handicap-index', value: handicapIndex, onChange: handleHandicapIndexChange, className: 's-input-handicap' }))),
        react_1.default.createElement("div", { className: 's-flex-column or-label' },
            react_1.default.createElement("div", { className: 's-input-section' },
                react_1.default.createElement("label", { className: 's-input-handicap-label' },
                    react_1.default.createElement("span", null, "OR")))),
        react_1.default.createElement("div", { className: 's-flex-column' },
            react_1.default.createElement("div", { className: 's-input-section' },
                react_1.default.createElement("label", { className: 's-input-handicap-label first', htmlFor: 'handicapDropdown' }, "Select your estimated average score"),
                react_1.default.createElement("div", { className: 'dropdown-container', id: 'handicapDropdown' }, handicapDropdown()))),
        react_1.default.createElement("div", { className: 's-flex-column' },
            react_1.default.createElement("div", { className: 's-input-section' }, !eventPreselected ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("label", { className: 's-input-handicap-label', htmlFor: 'course-dropdown' }, "Select Championship"),
                react_1.default.createElement("div", { className: 'dropdown-container', id: 'handicapDropdown' }, courseDropdown()))) : null))));
}
exports.ScreenInput = ScreenInput;
